import { useBookingContext } from '../BookingContext'
import { Calendar } from '@w/components/ui/calendar'
import { Card, CardContent } from '@w/components/ui/card'
import { format, parse } from 'date-fns'
import { CalendarDays } from 'lucide-react'

export default function CalendarPicker() {
  const {
    availability,
    selectedDate,
    currentMonth,
    selectDate,
    setCurrentMonth,
  } = useBookingContext()

  // Convert selected date string to Date object
  const selectedDateObj = selectedDate
    ? parse(selectedDate, 'yyyy-MM-dd', new Date())
    : undefined

  // Get available dates from availability map
  const availableDates = Object.keys(availability).filter(
    (date) => availability[date] && availability[date].length > 0
  )

  // Matcher function for react-day-picker
  const isDateAvailable = (date: Date) => {
    const dateStr = format(date, 'yyyy-MM-dd')
    return availableDates.includes(dateStr)
  }

  // Handle date selection
  const handleDateSelect = (date: Date | undefined) => {
    if (date && isDateAvailable(date)) {
      const dateStr = format(date, 'yyyy-MM-dd')
      selectDate(dateStr)
    }
  }

  // Handle month change
  const handleMonthChange = (date: Date) => {
    setCurrentMonth(date)
  }

  return (
    <Card>
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-6">
          <CalendarDays className="w-5 h-5 text-primary" />
          <h3 className="font-semibold text-xl">Select a Date</h3>
        </div>

        <div className="flex justify-center">
          <Calendar
            mode="single"
            selected={selectedDateObj}
            onSelect={handleDateSelect}
            month={currentMonth}
            onMonthChange={handleMonthChange}
            disabled={(date) => !isDateAvailable(date) || date < new Date(new Date().setHours(0, 0, 0, 0))}
            modifiers={{
              available: isDateAvailable,
            }}
            modifiersStyles={{
              available: {
                fontWeight: '600',
              },
            }}
            className="rounded-md border-0"
          />
        </div>

        <div className="mt-6 pt-4 border-t flex items-center justify-center gap-4 text-xs text-muted-foreground">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-primary"></div>
            <span>Available</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full border-2 border-muted"></div>
            <span>Unavailable</span>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
